import { gql } from "@apollo/client"
import { KeyValuePair } from "./EledoPlanState"
import { EledoNotificationsConfig } from "./EledoAccountQueries"

export type EledoProfile = {
  name: string
	locale: string
	timezone: string
	language: string
	countryCode: string
	properties: KeyValuePair[]
	counters: KeyValuePair[]
	notifications: EledoNotificationsConfig
	autoActivate: boolean
	billTo: EledoAddress
	vendorId: string
}

export type EledoAddress = {
	full_name: string
	address_line_1: string
	address_line_2: string
  admin_area_2: string
	postal_code: string
	country_code: string
	tax_id: string
}

export type EledoAddressInput = {
	full_name: string
	address_line_1: string
	address_line_2: string
  admin_area_2: string
	postal_code: string
	country_code: string
	tax_id: string
}

export type EledoProfileVars = {
}

export type EledoProfileData = {
  currentProfile: EledoProfile
}

export type UpdateEledoProfileVars = {
  profile: EledoProfile
}

export type UpdateEledoProfileData = {
  updateCurrentProfile: EledoProfile
}

export const GET_CURRENT_PROFILE = gql`
  query getCurrentProfile {
    currentProfile { id name locale timezone language countryCode properties { key value } counters { key value } autoActivate
      notifications { warnLimit80 warnLimit100 paymentReceived opsEmail paymentEmail paymentPDFAttachment helpdeskReply monthlyReport }
      billTo { full_name address_line_1 address_line_2 admin_area_2 postal_code country_code tax_id } vendorId }
  }
`;

export const UPDATE_CURRENT_PROFILE = gql`
  mutation updateCurrentProfile($profile: EledoProfileInput) {
    updateCurrentProfile(profile: $profile) { id name locale timezone language countryCode properties { key value } counters { key value } autoActivate
      notifications { warnLimit80 warnLimit100 paymentReceived opsEmail paymentEmail paymentPDFAttachment helpdeskReply monthlyReport }
      billTo { full_name address_line_1 address_line_2 admin_area_2 postal_code country_code tax_id } vendorId }
  }
`;

